"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const rn_css_1 = require("rn-css");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const Logo = ({ size = 50, short }) => {
    const theme = (0, rn_css_1.useTheme)();
    const currentTheme = theme || base_ui_theme_themes_1.defaultTheme;
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const normalizedSize = normalize(size);
    if (short) {
        return (react_1.default.createElement(react_native_1.Image, { style: { height: normalizedSize, width: normalizedSize }, source: require('./assets/logoShortLarge.png') }));
    }
    return (react_1.default.createElement(react_native_1.Image, { style: { height: normalizedSize, width: 3 * normalizedSize }, source: (0, base_ui_theme_themes_1.isDarkTheme)(currentTheme) ? require("./assets/logoDark.png") : require("./assets/logoLight.png") }));
};
exports.Logo = Logo;
//# sourceMappingURL=logo.js.map